import type { FunctionComponent, ReactNode } from 'react';

import { NavLink } from '@dr.pogodin/react-utils';

import './style.scss';

type PropsT = {
  end?: boolean;
  expanded?: boolean;
  icon: ReactNode;
  name: string;
  onClick?: () => void;
  to: string;
};

const Item: FunctionComponent<PropsT> = ({
  end,
  expanded = true,
  icon,
  name,
  onClick,
  to,
}) => (
  <NavLink
    end={end}
    onClick={onClick}
    styleName={`container ${expanded ? 'expanded' : ''}`}
    to={to}
  >
    <span styleName="icon">{icon}</span>
    <span styleName="label">{name}</span>
  </NavLink>
);

export default Item;
